module.exports = __webpack_public_path__ + "img/mint-tokens.5a9758a8.png";